/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetFlockGroupQueryVariables = Types.Exact<{
  userId: Types.Scalars["Float"];
}>;

export type GetFlockGroupQuery = {
  flockGroupSelfWithDetailedGroupMemberInfo: Array<
    Pick<
      Types.DetailedFlockMember,
      | "eventAttendeeId"
      | "location"
      | "instagramLink"
      | "facebookLink"
      | "twitterLink"
      | "linkedinLink"
      | "discordTag"
      | "email"
      | "name"
    >
  >;
};

export const GetFlockGroupDocument = gql`
  query GetFlockGroup($userId: Float!) {
    flockGroupSelfWithDetailedGroupMemberInfo(userId: $userId) {
      eventAttendeeId
      location
      instagramLink
      facebookLink
      twitterLink
      linkedinLink
      discordTag
      email
      name
    }
  }
`;

/**
 * __useGetFlockGroupQuery__
 *
 * To run a query within a React component, call `useGetFlockGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlockGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlockGroupQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetFlockGroupQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetFlockGroupQuery,
    GetFlockGroupQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetFlockGroupQuery,
    GetFlockGroupQueryVariables
  >(GetFlockGroupDocument, baseOptions);
}
export function useGetFlockGroupLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetFlockGroupQuery,
    GetFlockGroupQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetFlockGroupQuery,
    GetFlockGroupQueryVariables
  >(GetFlockGroupDocument, baseOptions);
}
export type GetFlockGroupQueryHookResult = ReturnType<
  typeof useGetFlockGroupQuery
>;
export type GetFlockGroupLazyQueryHookResult = ReturnType<
  typeof useGetFlockGroupLazyQuery
>;
export type GetFlockGroupQueryResult = ApolloReactCommon.QueryResult<
  GetFlockGroupQuery,
  GetFlockGroupQueryVariables
>;
